<template>
    <div class="send-message-overlay" :class="{'is-active' : isActive}" v-if="user">
        <div class="send-message-container">
            <h3 class="send-message__title">{{word.send_request}}</h3>
            <a :href="buildProfileLink(user)" class="send-message__user" target="_blank">
                <img :src="user.avatar" :alt="user.name">
                {{ user.name }}
            </a>
            <div class="send-message__text">
                <textarea cols="30" v-model="txt" :placeholder="text.say_something"></textarea>
            </div>
            <div class="send-message__actions">
                <button class="btn btn-success" @click="sendMessage">{{word.send}}</button>
                <span @click="closeModal">{{word.cancel}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";

    export default {
        name: "message-modal",

        components: {
            Swal
        },

        data() {
            return {
                user: null,
                isActive: false,
                txt: '',
                word: window.word,
                text: window.text,
            };
        },

        methods: {
            buildProfileLink(user) {
                return `/${window.locale}/user/${user.user_name}`;
            },
            sendMessage() {
                axios.post('/api/v1/chat', {user_id: this.user.id, text: this.txt},{params : {token : window.jwt_token}})
                    .then(response => {
                        if (response.status === 201) {
                            this.$toast.success(this.text.your_request_has_been_sent_successfully);

                            this.closeModal();
                        }

                        if (response.status === 200) {
                            this.$toast.warning(this.text.you_cant_send_two_request_to_the_same_person);
                        }
                    })
                    .catch(error => {

                        if (error.response.data.type && error.response.data.type === 'canFeatureValidation') {
                            Swal.fire({
                                title: 'Attention',
                                text: this.text.can_send_message_feature_error,
                                icon: 'warning',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Upgrade',
                                cancelButtonText: 'Cancel',
                                /* confirmButtonClass: 'btn btn-success',
                                 cancelButtonClass: 'btn btn-danger',*/
                                buttonsStyling: true,
                                closeOnConfirm: false,
                                closeOnCancel: false
                            }).then((result) => {
                                if (result.value) {
                                    window.location = '/select-plan'
                                }
                            })
                        }

                        if (error.response.status === 422) {
                            this.$toast.error(this.text.please_fill_message_field);
                        }

                        if (error.response.status === 400) {
                            this.$toast.error(this.word.blocked);
                        }
                    });
            },
            closeModal() {
                this.isActive = false;
                this.txt = '';
                this.user = null;
            }
        },

        mounted() {
            Bus.$on('showCreateChatModal', (e) => {
                this.user = e.user;
                this.isActive = true;
            });
        }
    }
</script>

<style scoped>
    .send-message-overlay {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1001;
        background-color: rgba(0, 0, 0, 0.6);
        display: none;
    }

    .send-message-overlay.is-active {
        display: block;
    }

    .send-message-container {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -250px;
        margin-left: -250px;
        width: 500px;
        height: 500px;
        border-radius: 8px;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);
        padding: 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .send-message__title {
        text-align: center;
        font-size: 17px;
        font-weight: bold;
        padding-bottom: 20px;
        border-bottom: 1px solid #f9f9f9;
    }

    .send-message__user {
        line-height: 30px;
        color: #333;
        display: block;
        padding: 10px 0;
    }

    .send-message__user img {
        border-radius: 50%;
        width: 60px;
        height: 60px;
        margin-right: 15px;
        border: 1px solid #f9f9f9;
    }

    .send-message__text {
        flex: 1;
        padding: 15px 0;
    }

    .send-message__text textarea {
        border-radius: 4px;
        border: 1px solid #f0f0f0;
        padding: 15px;
        height: 100%;
    }

    .send-message__text textarea:focus {
        border-color: #a0a0a0;
    }

    .send-message__actions {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
    }

    .send-message__actions button {
        padding: 9px 25px;
        font-size: 13px;
    }

    .send-message__actions span {
        color: #777;
        margin: 9px 0;
        font-size: 13px;
    }

    .send-message__actions span:hover {
        cursor: pointer;
        color: #28abbf;
    }
</style>
